export enum ModalComponentName {
  REGISTRATION = 'Registration',
  RESTORE = 'Restore',
  INFO = 'Info',
  NAVIGATION_OPTIONS = 'NavigationOptions',
  SUPPORT = 'Support',
  BANNER_ACCESS = 'BannerAccess',
  LANGUAGE_WARNING = 'LanguageWarning',
  WEB_INFO = 'WebInfo',
  PROMO = 'Promo',
  SUBSCRIPTION_SUCCESS = 'SubscriptionSuccess',
  PROMO_NOT_REGISTERED = 'PromoNotRegistered',
  INSTALL_MOBILE_APP = 'InstallMobileApp',
  GO_TO_MOBILE_APP = 'GoToMobileApp',
  CLOSED_FOR_NOW = 'ClosedForNow',
  NOT_AVAILABLE = 'NotAvailable',
  AFTER_REPORT = 'AfterReport',
  COURSES_VIEW_CHANGED = 'CoursesViewChanged'
}

export enum SmartBannerType {
  SMART = 'smart',
  CUSTOM = 'custom'
}
